import { render, staticRenderFns } from "./listProducts.vue?vue&type=template&id=f08ede02&scoped=true&"
import script from "./listProducts.vue?vue&type=script&lang=js&"
export * from "./listProducts.vue?vue&type=script&lang=js&"
import style0 from "./listProducts.vue?vue&type=style&index=0&id=f08ede02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08ede02",
  null
  
)

export default component.exports